import { useRouteMatch } from "react-router-dom";

import { useSearchSectionRoutes } from "@/hooks/useSearchSectionRoutes";

export type InsightView = "overview" | "results" | "reach" | "sentiment";

export function useInsightView(): InsightView {
  const section = useSearchSectionRoutes();
  const isResults = Boolean(useRouteMatch(section.insightsResults));
  const isReach = Boolean(useRouteMatch(section.insightsReach));
  const isSentiment = Boolean(useRouteMatch(section.insightsSentiment));

  if (isResults) return "results";
  if (isReach) return "reach";
  if (isSentiment) return "sentiment";
  return "overview";
}
